/* eslint-disable global-require */
module.exports = ['marketplace.reporting.countrydropdown.m1'];
